function initSlider(){
    $('.quotes-slider').slick({
        slidesToShow: 1,
        infinite: true,
        speed: 300,
        autoplay: true,
        autoplaySpeed: 10000,
        arrows: false,
        dots: false,
        fade: true,
        pauseOnFocus: false,
        pauseOnHover: false,
        pauseOnDotsHover: false
    });

    var breakpoints = {
        xxl: {
            items: 10,
        },
        xl: {
            items: 8,
            width: 1400,
        },
        lg: {
            items: 6,
            width: 1200,
        },
        md: {
            items: 5,
            width: 992,
        },
        sm: {
            items: 3,
            width: 768,
        },
        xs: {
            items: 2,
            width: 480,
        }
    };

    $('.logo-parade-slider').each(function() {
        var slider = $(this);
        var slideritems = slider.children().length;
        var options = {
            arrows: false,
            dots: false,
            infinite: false,
            speed: 350,
            slidesToShow: 10,
            slidesToScroll: 1,
            autoplay: true,
            autoplaySpeed: 4500,
            pauseOnHover: true,
            responsive: []
        };

        Object.keys(breakpoints).forEach(function(key) {
            let infinite = (slideritems > breakpoints[key].items);
            if (key === 'xxl') {
                options.slidesToShow = breakpoints[key].items;
                options.infinite = infinite;
            } else {
                options.responsive.push({
                    breakpoint: breakpoints[key].width,
                    settings: {
                        slidesToShow: breakpoints[key].items,
                        infinite: infinite,
                    }
                });
            }
        });

        $(this).slick(options);
    });

}
